export const parseError = (err) => {
    const fullErrorText = String(err);
    let errorText = fullErrorText.substring(('Error: GraphQL error:').length + 1);
    errorText = fullErrorText.substring(('Error:').length + 1);
    const text = errorText.substr(errorText.indexOf(':')+1)
    const field = errorText.slice(0, errorText.indexOf(':'))
    return {field, text}
}
